<template xmlns="">
  <div class="main-asset">
<!--    <header>-->
<!--      <h3>资产管理</h3>-->
<!--      &lt;!&ndash; <span>/ asset management</span> &ndash;&gt;-->
<!--    </header>-->
    <main>
      <header>
        <h3>资产管理</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button v-if="$IA('system:asset:save')" type="primary" icon="plus" @click="handleOpen('添加')"
          >添加</a-button
          >
        </div>
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText">
            <a-input-search v-model.trim="pagination.searchText" placeholder="名称/描述/值"
                            style="width: 200px; " allow-clear :loading="btnLoad" @input="searchTextChange"
                            @search="searchChange" />
          </a-form-model-item>
          <a-form-model-item prop="type">
            <a-select placeholder="类型" v-model="pagination.type" style="width: 180px;"
                      :loading="btnLoad" allowClear @change="searchChange">
              <a-select-option :value="0">文本</a-select-option>
              <a-select-option :value="1">布尔</a-select-option>
              <a-select-option :value="2">数值</a-select-option>
              <a-select-option :value="3">凭据</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item  prop="orgId">
            <a-tree-select
                v-model='pagination.orgId'
                allowClear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                @change="searchChange"
                style="width: 180px;"
                placeholder="部门"
                show-search
                :filterTreeNode="filter_tree_node"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item >
            <a-button  @click="resetSearch">重 置</a-button>
          </a-form-model-item>
        </a-form-model>

      </div>
      <!-- 数据表格 -->
      <a-table
        :columns="tableColumns"
        :data-source="tableData"
        :pagination="queryCondition"
        :loading="tableLoad"
        @change="handleTableChange"
        bordered
        :scroll="{ y: 560 }"
      >
        <template slot="type" slot-scope="text">
          {{ typeList[text] }}
        </template>
          <span slot="action" slot-scope="record" class="table-action-box">
            <a-tooltip  content="" v-if="$IA('system:asset:update')" title="修改" placement="top" effect="light">
              <i class="table-edit" @click="handleOpen('修改', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:asset:delete')" title="删除" placement="top" effect="light">
              <i class="table-delected" @click="handleOpen('删除', record)" ></i>
            </a-tooltip>
        </span>
      </a-table>
    </main>

    <!-- 操作模态框 -->
    <a-modal
      centered
      :title="modalTitle + '资产'"
      :visible="modalVisible"
      :confirm-loading="submitLoad"
      @ok="handleOk"
      destroyOnClose
      :width="modalTitle == '删除'? '420px' : '580px'"
      @cancel="resetForm"
      :maskClosable="false"
      :footer="modalTitle == '查看' ? null : undefined"
    >
      <a-form-model
        v-if="['添加', '修改'].includes(modalTitle)"
        layout="vertical"
        :model="addForm"
        ref="addForm"
        :rules="addFormRules"
      >
        <a-form-model-item prop="id" v-show="false">
          <a-input v-model="addForm.id" placeholder="请输入" />
        </a-form-model-item>
        <a-row :gutter="23">
          <a-col :span="12">
            <a-form-model-item label="资产名称" prop="name">
              <a-input v-model="addForm.name" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="类型" prop="type">
              <a-select
                :disabled="['修改'].includes(modalTitle)"
                v-model="addForm.type"
                placeholder="请选择"
                @change="assetTypeChange"
              >
                <a-select-option :value="0">文本</a-select-option>
                <a-select-option :value="1">布尔</a-select-option>
                <a-select-option :value="2">数值</a-select-option>
                <a-select-option :value="3">凭据</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="部门" prop="orgId" >
              <a-tree-select
                v-model='addForm.orgId'
                allowClear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="选择部门"
                tree-default-expand-all
                show-search
                :filterTreeNode="filter_tree_node"
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
              >
              </a-tree-select>
            </a-form-model-item></a-col
          >
          <a-col :span="12" v-if="addForm.type == '1'">
            <a-form-model-item label="值" prop="value" :rules="[{required: true, message: '请选择布尔值'}]">
              <a-select v-model="addForm.value" placeholder="请选择">
                <a-select-option value="true">true</a-select-option>
                <a-select-option value="false">false</a-select-option>
              </a-select>
            </a-form-model-item></a-col
          >
          <a-col :span="12" v-if="addForm.type=='0'">
            <a-form-model-item label="值" prop="value">
              <a-input v-model="addForm.value" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="addForm.type=='2'">
            <a-form-model-item label="值" prop="value" :rules="[{required: true, message: '数值不能为空'}]">
              <a-input-number :min="-2147483648" :max="2147483647" :precision="0" v-model="addForm.value" placeholder="请输入" style="width: 100%;"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="addForm.type == '3'">
            <a-form-model-item label="用户名" prop="credentialUsername">
              <a-input
                v-model="addForm.credentialUsername"
                placeholder="请输入"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="addForm.type == '3'">
            <a-form-model-item label="密码" prop="credentialPassword"       
               :rules="{
                required: ['添加'].includes(modalTitle),
                message: '密码不能为空',
                trigger: 'blur',
              }">
              <a-input-password
                v-model="addForm.credentialPassword"
                placeholder="请输入"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="描述" prop="description">
              <a-textarea
                v-model="addForm.description"
                placeholder="请输入"
              /> </a-form-model-item
          ></a-col>
        </a-row>
      </a-form-model>

      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该资产,是否继续?</p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

export default {
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      submitLoad:false,
      pagination: {
        searchText: "",
        type: undefined,
        orgId:undefined,
        pageSize: 10,
        pageNo: 1,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      formLayout:"inline",
      queryCondition: {},
      // 分页参数
      pagCurrent:{},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
          ellipsis: true,
        },
        {
          title: "类型",
          key: "type",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
        },
        {
          title: "部门",
          key: "orgName",
          dataIndex: "orgName",
          ellipsis: true,
        },
        {
          title: "值",
          dataIndex: "value",
          key: "value",
          ellipsis: true,
        },
        {
          title: "描述",
          key: "description",
          dataIndex: "description",
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "action" },
        },
      ],
      tableData: [],
      // 模态框显隐
      modalVisible: false,  
      // 模态框标题
      modalTitle: "",
      // 添加/删除api
      saveApi: "",
      // 单条数据
      singleDta: "",
      // 部门列表
      treeData:[],
      // 添加表单
      addForm: {
        id: "",
        name: "",
        type: 0,
        orgId:undefined,
        description: "",
        value: undefined,
        credentialUsername: "",
        credentialPassword: "",
      },
      // 类型列表
      typeList: {
        0: "文本",
        1: "布尔",
        2: "数值",
        3: "凭据",
      },
      addFormRules: {
        name: [{ required: true, max: 255, message: "资产名称最长不能超过255字符且不可为空" }],
        type: [{ required: true, message: "类型不能为空" }],
        orgId: [{ required: true, message: "部门不能为空" }],
        description: [
          {max: 250, message: '描述最长不能超过250字符'}],
        value: [{ required: true, max: 5000, message: "值最长不能超过5000字符且不可为空" }],
        credentialUsername: [{ required: true, max: 32, message: "用户名最长不能超过32位字符且不可为空" }],
        credentialPassword: [{ required: true, max: 32, message: "密码最长不能超过32位字符且不可为空" }],
      },
    };
  },
  methods: {
    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 重置表单通用方法
    resetForm() {
      if (this.modalTitle == "添加" || this.modalTitle == "修改") {
        this.$refs.addForm.resetFields();
      }
      this.modalVisible = false
    },
    // 重置搜索
    resetSearch(){
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title;
      this.modalVisible = true;
      this.$nextTick(()=>{
        this.singleDta = data;
        switch (title) {
          case "添加":
            this.saveApi = "/asset/save";
            this.addFormRules.credentialPassword = [{required: true, max: 32, message: '密码最长不能超过32字符且不可为空'}]
            break;
          case "修改":
            this.saveApi = "/asset/update";
            this.addForm = this.$lodash.pick(
              this.singleDta,
              this.$lodash.keys(this.addForm)
            );
            if (this.addForm.type=='3') {
              this.addFormRules.credentialPassword = [{max: 32, message: '密码最长不能超过32字符'}]
            }
            break;
          case "删除":
            break;
        }
      })
    },
    // 确认模态框
    handleOk() {
      if (this.modalTitle == "添加" || this.modalTitle == "修改") {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.submitLoad = true;
            let saveData = this.$lodash.cloneDeep(this.addForm);
            saveData.credentialPassword = saveData.credentialPassword?this.$encrypt.encrypt(saveData.credentialPassword):null
            this.axios
              .post(this.saveApi, saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.handleTableChange(this.modalTitle == "添加"? this.pagination:this.pagCurrent);
                  this.resetForm()
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.submitLoad = true;
        this.axios
          .delete("/asset/delete/" + this.singleDta.id)
          .then((res) => {
            this.submitLoad = false;
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.handleTableChange(this.pagCurrent);
              this.modalVisible = false;
            }
          })
          .catch((err) => {
            this.submitLoad = false;
            console.log(err);
          });
      }
    },
    // 监听类型
    assetTypeChange(val) {
      // 监听: 资产类型
      this.addForm.value = undefined;
      if (val === 3) {
        // 选择了凭据
        this.addForm.credentialUsername = "";
        this.addForm.credentialPassword = "";
        this.addForm.value = "";
      }
    },
    // 部门下拉框
    allorgList() {
      this.axios
        .post("/org/findOrg",'')
        .then((res) => {
          if (res.code === 200) {
            this.treeData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 监听搜索输入框输入
    searchTextChange(val){
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
        // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =   pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
        .post("/asset/findPage", this.$qs.stringify(this.queryCondition))
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.queryCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
  },
  beforeMount() {
    this.searchChange();
    this.allorgList()
  },
};
</script>

<style lang="scss" scoped>
.main-asset {

  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }


    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;
          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }


  }
}
::v-deep .ant-col-12 {
  height: 104px;
}
</style>